import { removeImageBackground, detectImageObjects, analyzeImageScene } from '../harness/scenereader-harness';
import { SCENEREADER_PROMPTS } from '../prompts/scenereader';

export async function buildSceneReaderContext(textPrompt: string, imageBase64?: string): Promise<string> {
    const lowerPrompt = textPrompt.toLowerCase();
    
    const isBgRemoval = lowerPrompt.includes("remove background") || lowerPrompt.includes("remove the background") || lowerPrompt.includes("transparent");
    const isDetectObjects = lowerPrompt.includes("detect object") || lowerPrompt.includes("what is in this") || lowerPrompt.includes("bounding box") || lowerPrompt.includes("hud") || lowerPrompt.includes("read hud") || lowerPrompt.includes("find object");
    const isAnalyzeScene = lowerPrompt.includes("analyze scene") || lowerPrompt.includes("describe image") || lowerPrompt.includes("what is this image") || lowerPrompt.includes("tags") || lowerPrompt.includes("moderation") || lowerPrompt.includes("analyzing image");

    if (isBgRemoval || isDetectObjects || isAnalyzeScene) {
        if (!imageBase64) {
            return SCENEREADER_PROMPTS.NO_IMAGE();
        }
        
        if (isBgRemoval) {
            const result = await removeImageBackground(imageBase64);
            return result ? SCENEREADER_PROMPTS.BG_REMOVED(result) : SCENEREADER_PROMPTS.FAILED("Background Removal");
        }
        
        if (isDetectObjects) {
            const detections = await detectImageObjects(imageBase64);
            return detections ? SCENEREADER_PROMPTS.OBJECTS_DETECTED(detections) : SCENEREADER_PROMPTS.FAILED("Object Detection");
        }
        
        if (isAnalyzeScene) {
            const analysis = await analyzeImageScene(imageBase64);
            return analysis ? SCENEREADER_PROMPTS.SCENE_ANALYZED(analysis) : SCENEREADER_PROMPTS.FAILED("Scene Analysis");
        }
    }
    
    return "";
}
